import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mailCheckFilled"
const MailCheckFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.44 14.875 22.5 15.782 22.939 16.158 16.326 23.875 11.625 19.175 13.02 17.778 16.214 20.972z" />
          <path d="M22.334 5.567C22.439 5.772 22.5 6.004 22.5 6.25V13.183L21.227 12.093 16.102 18.07 13.02 14.989 8.834 19.174 10.91 21.25H3C2.172 21.25 1.5 20.578 1.5 19.75V6.25C1.5 6.004 1.56 5.772 1.666 5.567L12 14.753z" />
          <path d="M12 12.747 3.004 4.75H20.996z" />
        </svg>
      }
    </span>
  )
}
export default MailCheckFilledIcon
